module.exports = __webpack_public_path__ + "static/media/DA1A645F2AD99101.e03099dc.png";